//# sourceMappingURL=position.mjs.map
/// <reference types="./position.d.mts" />
import * as $dynamic from "../../gleam_stdlib/gleam/dynamic.mjs";
import * as $float from "../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $window from "../../magellan/magellan/window.mjs";
import * as $redraw from "../../redraw/redraw.mjs";
import * as $attribute from "../../redraw_dom/redraw/dom/attribute.mjs";
import * as $h from "../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../sketch/sketch/css.mjs";
import * as $length from "../../sketch/sketch/css/length.mjs";
import { px, px_ } from "../../sketch/sketch/css/length.mjs";
import { styled } from "../../sketch_redraw/sketch/redraw.mjs";
import * as $function from "../../tiamat/tiamat/function.mjs";
import { prepend as listPrepend, CustomType as $CustomType } from "../gleam.mjs";
import { getParentPosition as parent } from "./position.ffi.mjs";

export { parent };

export class Box extends $CustomType {
  constructor(top, bottom, left, right, width, height, x, y) {
    super();
    this.top = top;
    this.bottom = bottom;
    this.left = left;
    this.right = right;
    this.width = width;
    this.height = height;
    this.x = x;
    this.y = y;
  }
}
export const Box$Box = (top, bottom, left, right, width, height, x, y) =>
  new Box(top, bottom, left, right, width, height, x, y);
export const Box$isBox = (value) => value instanceof Box;
export const Box$Box$top = (value) => value.top;
export const Box$Box$0 = (value) => value.top;
export const Box$Box$bottom = (value) => value.bottom;
export const Box$Box$1 = (value) => value.bottom;
export const Box$Box$left = (value) => value.left;
export const Box$Box$2 = (value) => value.left;
export const Box$Box$right = (value) => value.right;
export const Box$Box$3 = (value) => value.right;
export const Box$Box$width = (value) => value.width;
export const Box$Box$4 = (value) => value.width;
export const Box$Box$height = (value) => value.height;
export const Box$Box$5 = (value) => value.height;
export const Box$Box$x = (value) => value.x;
export const Box$Box$6 = (value) => value.x;
export const Box$Box$y = (value) => value.y;
export const Box$Box$7 = (value) => value.y;

export class Right extends $CustomType {}
export const Position$Right = () => new Right();
export const Position$isRight = (value) => value instanceof Right;

export class Left extends $CustomType {}
export const Position$Left = () => new Left();
export const Position$isLeft = (value) => value instanceof Left;

export class Dimensions extends $CustomType {
  constructor(height, width) {
    super();
    this.height = height;
    this.width = width;
  }
}
export const Dimensions$Dimensions = (height, width) =>
  new Dimensions(height, width);
export const Dimensions$isDimensions = (value) => value instanceof Dimensions;
export const Dimensions$Dimensions$height = (value) => value.height;
export const Dimensions$Dimensions$0 = (value) => value.height;
export const Dimensions$Dimensions$width = (value) => value.width;
export const Dimensions$Dimensions$1 = (value) => value.width;

/**
 * Parent position class name, used to find the parent wrapper. Parent position
 * class name is used to later fetch the position of a parent of a node
 * with `parent_position`, in order to absolutely position the child,
 * for example.
 * 
 * @ignore
 */
export const wrapper_class = "is-positioned";

export const default_box = /* @__PURE__ */ new Box(
  0.0,
  0.0,
  0.0,
  0.0,
  0.0,
  0.0,
  0.0,
  0.0,
);

export function div(style, attrs, children) {
  let class$ = $attribute.class$(wrapper_class);
  let attrs$1 = listPrepend(class$, attrs);
  return styled("div", style, attrs$1, children);
}

export function div_(attrs, children) {
  let class$ = $attribute.class$(wrapper_class);
  let attrs$1 = listPrepend(class$, attrs);
  return $h.div(attrs$1, children);
}

/**
 * Wrap the children in any node whose class name contains the positioned indicator.
 */
export function wrapper(tag, style, attrs, children) {
  let class$ = $attribute.class$(wrapper_class);
  let attrs$1 = listPrepend(class$, attrs);
  return styled(tag, style, attrs$1, children);
}

export function wrapper_(tag, attrs, children) {
  let class$ = $attribute.class$(wrapper_class);
  let attrs$1 = listPrepend(class$, attrs);
  return $h.element(tag, attrs$1, children);
}

function bottom_position(box) {
  let win = $window.self();
  let height = $window.inner_height(win);
  let bottom = (height - $float.round(box.y)) + 6;
  return $css.bottom(px(bottom));
}

function top_position(box) {
  let top = ((0 + $float.round(box.y)) + $float.round(box.height)) + 6;
  return $css.top(px(top));
}

function is_third_quarter_down(box) {
  let box_height = $float.round(box.y + box.height);
  let win = $window.self();
  let height = $window.inner_height(win);
  let third_page_height = 3 * (globalThis.Math.trunc(height / 4));
  return box_height > third_page_height;
}

/**
 * Computes the vertical position of an absolutely positioned element, relative
 * to its parent position. The `box` provided in argument is the current parent
 * position in the DOM.
 */
export function vertical(box) {
  let $ = is_third_quarter_down(box);
  if ($) {
    return bottom_position(box);
  } else {
    return top_position(box);
  }
}

export function horizontal(box, position) {
  if (position instanceof Right) {
    let win = $window.self();
    let width = $window.inner_width(win);
    let width$1 = $int.to_float(width);
    return $css.right(px_(width$1 - box.right));
  } else {
    return $css.left(px_(box.left));
  }
}

function inner_dimensions() {
  let win = $window.self();
  let height = $window.inner_height(win);
  let width = $window.inner_width(win);
  return new Dimensions(height, width);
}

export function use_dimensions() {
  let $ = $redraw.use_lazy_state(inner_dimensions);
  let dimensions = $[0];
  let set_dimensions = $[1];
  return $function.tap(
    dimensions,
    (_) => {
      return ((_capture) => { return $redraw.use_effect_(_capture, []); })(
        () => {
          let sub = (_) => { return set_dimensions(inner_dimensions()); };
          $window.add_event_listener("resize", sub);
          return () => { return $window.remove_event_listener("resize", sub); };
        },
      );
    },
  );
}

export function use_max_height(box) {
  let dimensions = use_dimensions();
  return ((_capture) => { return $redraw.use_memo(_capture, [box, dimensions]); })(
    () => {
      let height = dimensions.height;
      let paddings = 18;
      let height$1 = $int.min(
        500,
        (() => {
          let $ = is_third_quarter_down(box);
          if ($) {
            return (height - (height - $float.round(box.y))) - paddings;
          } else {
            return (height - $float.round(box.y + box.height)) - paddings;
          }
        })(),
      );
      return $css.max_height(px(height$1));
    },
  );
}
